import React, { useState } from 'react';
import {
  admins,
  advisers,
  afTool,
  caseManagement,
  clubs,
  firms,
  networks,
  prefix,
  commissionTerms,
} from 'routes/routePaths';

import css from './Dashboard.module.scss';
import { Link as ReactLink, LinkProps } from 'react-router-dom';
import { useEffect } from 'react';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';
import { showNewCaseManTile } from 'utils/featureToggle/featureFactory';

export interface Link extends LinkProps {
  label: string;
  toExternal?: string;
}

const getLinksGroups = (): Link[] => {
  return [
    { label: 'Firms', to: firms.list },
    { label: 'Networks', to: networks.list },
    { label: 'Clubs', to: clubs.list },
    { label: 'Advisers', to: advisers.search },
    { label: 'Managers', to: admins.list },
    { label: 'Case Origination Platform', to: caseManagement.index },
    { label: 'Commission terms', to: commissionTerms.index },
    { label: 'AF Tool', to: afTool.index },
    ...showNewCaseManTile(),
  ];
};

const Dashboard: React.FC & PageLayoutParams = () => {
  const [links, setLinks] = useState<Link[]>([]);

  useEffect(() => {
    setLinks(getLinksGroups());
  }, []);

  return (
    <div className={css.pageWrapper}>
      <div className={css.wrapper}>
        {links.map((link, i: number) => (
          <div className={css.item} key={`link-${i}`}>
            {link.toExternal ? (
              <a href={link.toExternal} className={css.link}>
                {link.label}
              </a>
            ) : (
              <ReactLink to={link.to || prefix} className={css.link}>
                {link.label}
              </ReactLink>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

Dashboard.layout = Layouts.PANEL;

export default Dashboard;
